import { render, staticRenderFns } from "./recent-activity.view.vue?vue&type=template&id=87331b6e&scoped=true&"
import script from "./recent-activity.view.ts?vue&type=script&lang=ts&"
export * from "./recent-activity.view.ts?vue&type=script&lang=ts&"
import style0 from "./recent-activity.view.scss?vue&type=style&index=0&id=87331b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87331b6e",
  null
  
)

export default component.exports